export interface KrybotAssistantMessageShape {
  who: 'user' | 'assistant' | 'system';
  type?: string;
  text?: string;
  metadata?: {
    error?: string;
    [key: string]: unknown;
  };
}

export const isKrybotAssistantError = (message: KrybotAssistantMessageShape): boolean => {
  if (message.who !== 'assistant') {
    return false;
  }
  if (message.type === 'error') {
    return true;
  }
  const metadataError = message.metadata?.error;
  return typeof metadataError === 'string' && metadataError.trim().length > 0;
};

export const readKrybotErrorText = (message: KrybotAssistantMessageShape): string => {
  const metadataError = message.metadata?.error;
  if (typeof metadataError === 'string' && metadataError.trim().length > 0) {
    return metadataError.trim();
  }
  if (message.text?.trim()) {
    return message.text.trim();
  }
  return 'Krybot encountered an error processing your message.';
};
